/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GenericApiResponseDictData } from './genericApiResponseDictData';
import type { GenericApiResponseDictMessage } from './genericApiResponseDictMessage';
import type { GenericApiResponseDictPagination } from './genericApiResponseDictPagination';
import type { GenericApiResponseDictError } from './genericApiResponseDictError';

export interface GenericApiResponseDict {
  data?: GenericApiResponseDictData;
  message?: GenericApiResponseDictMessage;
  pagination?: GenericApiResponseDictPagination;
  error?: GenericApiResponseDictError;
  statusCode?: number;
}
